import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_list_management_assembly" }
];

const AssemblyListing = Loadable({
  loader: () => import("container/management/auto/assembly"),
  loading() {
    return <Loader />;
  }
});

export const assemblyRoutes: IRoute[] = [
  {
    path: "/management/assembly",
    element: <AssemblyListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
